const ADMIN_ROLE_NAMES = new Set(['ROLE_ADMIN', 'ADMIN']);

const normalizeRoles = (roles) => {
    if (!roles) return [];
    if (Array.isArray(roles)) {
        return roles;
    }
    if (typeof roles === 'string') {
        return roles
            .split(/[, ]+/)
            .map((role) => role.trim())
            .filter(Boolean);
    }
    if (typeof roles === 'object') {
        if (Array.isArray(roles.roles)) {
            return roles.roles;
        }
        if (Array.isArray(roles.value)) {
            return roles.value;
        }
    }
    return [];
};

export const hasAdminRole = (roles) =>
    normalizeRoles(roles).some((role) => ADMIN_ROLE_NAMES.has(role));
